import { create } from "zustand";

export const useExlyFeedbacksStore = create((set) => ({
  offeringFeedbackSettingsModalOpen: false,
  setOfferingFeedbackSettingsModalOpen: (value) =>
    set({ offeringFeedbackSettingsModalOpen: value }),

  gracePeriodModal: {
    open: false,
    baseValue: false,
    close: () =>
      set({
        gracePeriodModal: {
          open: false,
          baseValue: false,
          close: () => {},
        },
      }),
  },

  setGracePeriodModalOpen: ({ open, baseValue }) =>
    set({
      gracePeriodModal: {
        open,
        baseValue,
        close: () =>
          set({
            gracePeriodModal: {
              open: false,
              baseValue: false,
              close: () => {},
            },
          }),
      },
    }),
}));
